import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';

const firebaseConfig = {
  apiKey: "AIzaSyBTMiBgqxNpGcEWgZo7bzizyDywLFgz508",
  authDomain: "revival-church-f2637.firebaseapp.com",
  projectId: "revival-church-f2637",
  storageBucket: "revival-church-f2637.appspot.com",
  messagingSenderId: "795337865984",
  appId: "1:795337865984:web:c9e2a3bf356412d89011e5"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export const useAuthState = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return { user, loading };
};

export { auth };
